/* ═══════════════════════════════════════════════════
       CONSULTATION MODAL
    ═══════════════════════════════════════════════════ */
    function openModal() {
      document.getElementById('consultation-modal').classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      document.getElementById('consultation-modal').classList.remove('is-open');
      document.body.style.overflow = '';
      // Reset modal to form view when closed
      setTimeout(function() {
        var ok = document.getElementById('cf-modal-ok');
        var body = document.getElementById('cf-modal-body');
        if (ok && body) {
          ok.style.display = 'none';
          body.style.display = '';
        }
      }, 320);
    }

    function handleOverlayClick(e) {
      if (e.target === document.getElementById('consultation-modal')) {
        closeModal();
      }
    }

    // ESC key closes modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });


    /* ═══════════════════════════════════════════════════
       CONTACT FORM — Dropdowns, Date, AJAX submit
    ═══════════════════════════════════════════════════ */

    (function () {

      /* ── Custom dropdowns ── */
      function initDropdowns() {
        document.querySelectorAll('.cf-cdd:not([data-cf-ready])').forEach(function (cdd) {
          cdd.setAttribute('data-cf-ready', '1');
          var btn = cdd.querySelector('.cf-cdd-btn');
          var lbl = cdd.querySelector('.cf-cdd-lbl');
          // The hidden input is a sibling, not inside the .cf-cdd
          var hiddenInput = cdd.parentElement.querySelector('input[type="hidden"]');

          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            var isOpen = cdd.classList.contains('is-open');
            closeAllDropdowns();
            if (!isOpen) cdd.classList.add('is-open');
          });

          cdd.querySelectorAll('.cf-cdd-opt').forEach(function (opt) {
            opt.addEventListener('click', function (e) {
              e.stopPropagation();
              cdd.querySelectorAll('.cf-cdd-opt').forEach(function (o) { o.classList.remove('is-sel'); });
              opt.classList.add('is-sel');
              lbl.textContent = opt.textContent;
              cdd.classList.add('has-val');
              cdd.classList.remove('is-open');
              if (hiddenInput) hiddenInput.value = opt.textContent;
            });
          });
        });
      }

      function closeAllDropdowns() {
        document.querySelectorAll('.cf-cdd.is-open').forEach(function (c) {
          c.classList.remove('is-open');
        });
      }
      document.addEventListener('click', closeAllDropdowns);

      /* ── Date inputs — toggle has-date class for placeholder color ── */
      function initDateInputs() {
        document.querySelectorAll('input[type="date"].cf-in').forEach(function (d) {
          d.addEventListener('change', function () {
            d.classList.toggle('cf-has-date', !!d.value);
          });
        });
      }

      /* ── Modal form — AJAX submit so no page reload ── */
      function initModalForm() {
        var modalBody = document.getElementById('cf-modal-body');
        if (!modalBody) return;
        var form = modalBody.querySelector('form');
        if (!form) return;

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('.cf-submit');
          if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }

          fetch(form.action || '/contact', {
            method: 'POST',
            body: new URLSearchParams(new FormData(form)),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(function () {
            // Fade out form body, fade in success
            modalBody.style.transition = 'opacity 0.22s ease';
            modalBody.style.opacity = '0';
            setTimeout(function () {
              modalBody.style.display = 'none';
              var ok = document.getElementById('cf-modal-ok');
              if (ok) {
                ok.style.display = 'block';
                ok.style.opacity = '0';
                ok.style.transition = 'opacity 0.3s ease';
                requestAnimationFrame(function () {
                  requestAnimationFrame(function () { ok.style.opacity = '1'; });
                });
              }
            }, 230);
          })
          .catch(function () {
            // On network error, fallback to normal submit
            if (btn) { btn.disabled = false; btn.style.opacity = ''; }
            form.submit();
          });
        });
      }

      /* ── Init ── */
      function init() {
        initDropdowns();
        initDateInputs();
        initModalForm();
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }

    }());


    /* ═══════════════════════════════════════════════════
       INDUSTRY SELECTOR
    ═══════════════════════════════════════════════════ */
    (function () {
      var list    = document.getElementById('industry-list');
      if (!list) return;
      var items   = list.querySelectorAll('.industry-item');
      var images  = document.querySelectorAll('.industry-image');
      var DURATION = 5000;
      var timer, activeIndex = 0;

      function goTo(idx) {
        items[activeIndex].classList.remove('is-active');
        images[activeIndex].classList.remove('is-active');
        activeIndex = idx;
        items[activeIndex].classList.add('is-active');
        images[activeIndex].classList.add('is-active');
      }

      function next() { goTo((activeIndex + 1) % items.length); }

      function startAuto() { timer = setInterval(next, DURATION); }
      function stopAuto()  { clearInterval(timer); }

      items.forEach(function (item) {
        item.addEventListener('click', function () {
          stopAuto();
          goTo(parseInt(item.dataset.index, 10));
          startAuto();
        });
      });

      startAuto();
    }());


    /* ═══════════════════════════════════════════════════
       PROCESS — IntersectionObserver entrance
    ═══════════════════════════════════════════════════ */
    (function () {
      var timeline = document.getElementById('process-timeline');
      if (!timeline) return;

      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          timeline.classList.add('is-visible');
          observer.disconnect();
        }
      }, { threshold: 0.15 });

      observer.observe(timeline);
    }());


    /* ═══════════════════════════════════════════════════
       WORK TABS
    ═══════════════════════════════════════════════════ */
    (function () {
      var tabs   = document.querySelectorAll('.work-tab');
      var panels = document.querySelectorAll('.work-panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.panel;
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          tab.classList.add('is-active');
          var panel = document.querySelector('.work-panel[data-panel="' + target + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    }());